"use strict";

define('model/role',['./base'], function (BaseModel) {
  var Role = BaseModel.extend({}, {
    all: function all() {
      return this.createCollection('/rs/api/role');
    }
  });
  return Role;
});

